
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zakat/calculator",
      function () {
        return require("private-next-pages/zakat/calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zakat/calculator"])
      });
    }
  